import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    errorMessage:'',
    status:'initial',
    staffAccount:[],
    businessAccount:[],
};
const accountReducer = createSlice({
    name: 'account',
    initialState,
    reducers:{
        setResetaccount: (state)=>{
            state.errorMessage = '';
            state.status = 'initial';
            state.staffAccount = [];
        },
        setLoadingAccounts: (state)=>{
            state.errorMessage = '';
            state.status = 'loading';
        },
        setSuccessAccounts: (state,action)=>{
            state.errorMessage = '';
            state.status = 'success';
            state.staffAccount=action.payload.staff;
            state.businessAccount=action.payload.business;
        },
        setErrorAccount: (state,action)=>{
            state.errorMessage = action.payload;
            state.status = 'error';
        },
    },
});

export default accountReducer.reducer;
export const {setResetaccount,setErrorAccount,setLoadingAccounts,setSuccessAccounts} = accountReducer.actions;